// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__1s_Ox","OrderButton":"BuildControls_OrderButton__1IIoY"};